import React from "react";

const Footer = () => {
  return <footer>All Rights Reserved</footer>;
};

export default Footer;
